import React from "react";
import PropTypes from "prop-types";

import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";

const Fieldset = (props) => {
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const info = props.tooltip ? <Tooltip tooltipColor={props.tooltipColor} text={props.tooltip} tooltipType={tooltiptype} windowWidth={props.tooltipWindowWidth} windowAlignRight={props.tooltipWindowAlignRight} /> : null;
	const titleText = props.title ? props.title : "";
	const title = titleText ? <legend>{props.title} {info}</legend> : null;
	const style = props.style || {};

	return (
		<fieldset className="c-fieldset" style={style}>
			{props.title ?
				<div className="c-fieldset__header o-col-12 u-clear">
					{title}
				</div> : null}
			{props.children}
		</fieldset>
	);
};

Fieldset.propTypes = {
	title: PropTypes.string,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	tooltipColor: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	tooltipWindowAlignRight: PropTypes.bool,
	children: PropTypes.node,
	style: PropTypes.object
};

export default Fieldset;